import classNames from 'classnames'
import { Field } from 'components'
import { Form, Formik } from 'formik'
import React, {useState} from 'react'
import { Button, Card, Col, Row } from 'react-bootstrap'
import { toPrice } from 'utils'
import * as Yup from 'yup'

export function ProductCard({ product, onAddToCart }) {
  const initialValues = {
    quantity: 1,
  }
  product.options !== null && product.options.length > 0 && product.options.forEach(optField => {
    initialValues[optField.code] = optField.options[0].code
  })

  const validationSchema = Yup.object().shape({
    quantity: Yup.number().required('Required'),
  })

  const submit = ({ quantity, ...options }) => {
    onAddToCart(product.id, quantity, options)
  }

  const [button, setButton] = useState({ color: 'primary', text: 'Add to Cart'});

  const handleClick = () => {
    setButton({color: 'success', text: 'Added to Cart'});
    setTimeout(() => {
      setButton({color: 'primary', text: 'Add to Cart'});
    }, 3000);
  };

  return (
    <Card className="h-100">
      <Card.Img
        variant="top"
        src={product.img}
        alt={`${product.title}`}
        className={classNames({ 'p-5': product.img_padding })}
      />
      <Card.Body className="d-flex flex-column justify-content-between">
        <div className="mb-3">
          <Card.Title className="text-transform-none">
            {product.title}
          </Card.Title>
          <p className="lead text-success heavyset">
            ${toPrice(product.price)}
            <span className="text-secondary font-weight-normal small pl-1">
              {product.currency}
            </span>
          </p>
          <Card.Text
            dangerouslySetInnerHTML={{
              __html: product.description,
            }}
          />
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={submit}
        >
          {({ values }) => (
            <Form>
              {product.options !== null && product.options.length > 0 && product.options.map(optField => (
                <Row key={optField.code}>
                  <Col>
                    <Field name={optField.code} label={optField.text} as='select' custom>
                      {optField.options.map(opt => (
                        <option key={opt.code} value={opt.code}>{opt.text}</option>
                      ))}
                    </Field>
                  </Col>
                </Row>
              ))}
              <Row className="mb-3">
                <Col>
                  <Field
                    name="quantity"
                    label="quantity"
                    type="number"
                    min="1"
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button variant={button.color} block type="submit" onClick={handleClick}>
                    {button.text}
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Card.Body>
    </Card>
  )
}

export default ProductCard
